import React from "react";
import "../../styles/SalesTable.css";

const SalesTable = ({ sales = [] }) => {

    return (

        <div className="report-card">

            <h3>

                Sales Report

            </h3>

            <table className="report-table">

                <thead>

                    <tr>

                        <th>Date</th>

                        <th>Orders</th>

                        <th>Revenue</th>

                    </tr>

                </thead>

                <tbody>

                    {sales.length === 0 ? (

                        <tr>

                            <td colSpan="3">

                                No Data

                            </td>

                        </tr>

                    ) : (

                        sales.map((row, index) => (

                            <tr key={index}>

                                <td>{row.date}</td>

                                <td>{row.orders}</td>

                                <td>

                                    ₹{row.revenue}

                                </td>

                            </tr>

                        ))

                    )}

                </tbody>

            </table>

        </div>

    );

};

export default SalesTable;